@if (currReport.hasFilterCards) {
  <div class="report-filter-cards">
    <app-dashboard-cards>
      <app-dashboard-filter-card title="DataSource Type">
        <ng-template>
          <app-lt-multiselect-t
            [data]="dataSourceTypeItems"
            panelWidth=""
            label="DataSource Type"
            textField="description"
            valueField="dataSourceTypeId"
            placeholder="Select Data Source Type..."
            (selectionChange)="externalFilterChange()"
          [(ngModel)]="dataSourceItemsSelected"></app-lt-multiselect-t>
        </ng-template>
      </app-dashboard-filter-card>
      <app-dashboard-filter-card title="Destination Endpoints">
        <ng-template>
          <app-lt-multiselect-t
            [data]="destinationEndpointItems"
            panelWidth=""
            textField="displayName"
            valueField="destinationEndpointId"
            placeholder="Select Destination Endpoints..."
            (selectionChange)="externalFilterChange()"
          [(ngModel)]="destinationEndpointItemsSelected"></app-lt-multiselect-t>
        </ng-template>
      </app-dashboard-filter-card>
      <app-dashboard-filter-card title="Server">
        <ng-template>
          <app-lt-multiselect-t
            [data]="serverItems"
            panelWidth=""
            textField="description"
            valueField="serverId"
            placeholder="Select Servers..."
            (selectionChange)="externalFilterChange()"
          [(ngModel)]="serverItemsSelected"></app-lt-multiselect-t>
        </ng-template>
      </app-dashboard-filter-card>
    </app-dashboard-cards>
  </div>
  <div class="report-command-button-group">
    <button type="button" class="btn btn-outline-secondary" (click)="resetFilters()">
      Reset Filters
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="applyFilters()" >
      Apply Filters
    </button>
  </div>
}

@if (currReport.tableVersion === 0) {
  @if (haveData) {
    <app-lt-generic-grid-wrapper
      [data]="filteredData"
      [columns]="reportColumns"
      [exportFileName]="currReport.exportFileName"
      [isResizeable]="true"
      [showExportToolbar]="true"
      [hasActionGoToColumn]="true"
      [actionGoToUsePrefix]="true"
      [actionGoToField]="'clientName'"
      [actionGoToPrefix]="'/editConfig'"
      [actionGoToUseAddlField]="true"
      [actionGoToFieldAddl]="['integrationName']"
      [actionGoToUseSuffix]="true"
      [actionGoToSuffix]="'0'"
      [loading]="gettingData"
      [enableAutoFit]="true"
      >
    </app-lt-generic-grid-wrapper>
  }
  @if (!haveData && gettingData) {
    <div class="empty_spacing_for_norecords">
      <app-lt-spinner></app-lt-spinner>
    </div>
  }
  @if (!haveData && !gettingData) {
    <div class="empty_spacing_for_norecords">
      <div class="no-records-message">Loading failed.</div>
    </div>
  }
}

